import { cn } from '@helpers/styleUtils';
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import PropTypes from 'prop-types';
import { forwardRef, memo } from 'react';

const bgColors = [
    'bg-blue-900',
];

const Avatar = memo(
    forwardRef(({ className = '', ...props }, ref) => (
        <AvatarPrimitive.Root
            ref={ref}
            className={cn(
                'relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full',
                className,
            )}
            {...props}
        />
    )),
);
Avatar.displayName = AvatarPrimitive.Root.displayName;

const AvatarImage = memo(
    forwardRef(({ className = '', ...props }, ref) => (
        <AvatarPrimitive.Image
            ref={ref}
            className={cn('aspect-square h-full w-full', className)}
            {...props}
        />
    )),
);
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

const AvatarFallback = memo(
    forwardRef(({ className = '', ...props }, ref) => {
        const randomBg = bgColors[Math.floor(Math.random() * bgColors.length)];
        return (
            <AvatarPrimitive.Fallback
                ref={ref}
                className={cn(
                    'flex h-full w-full items-center justify-center rounded-full text-white text-lg',
                    randomBg,
                    className,
                )}
                {...props}
            />
        );
    }),
);
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

Avatar.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    src: PropTypes.string,
    alt: PropTypes.string,
};

AvatarImage.propTypes = {
    className: PropTypes.string,
};

AvatarFallback.propTypes = {
    className: PropTypes.string,
};

export { Avatar, AvatarImage, AvatarFallback };
